import { LiquidityPool } from "../../PoolContext";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state";
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import { OptimizedImage, SortedImages, sortImages } from "../../functions/images";
import { isLogged } from "../../functions/session";
import DexxCard from "../cards/DexxCard";

export default function CardEarn(props: { info: LiquidityPool, className: string }): JSX.Element {

    let lp = props.info
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)
    const [assetInfo, setAssetInfo] = useState<any>()
    const [media, setMedia] = useState<any>()
    const [cardImage, setCardImage] = useState<OptimizedImage>()
    const [cardImageURLs, setCardImageURLs] = useState<OptimizedImage>()
    const assetUuid = lp.asset_a_uuid ? lp.asset_a_uuid : ""
    const logged = isLogged()

    useEffect(() => {
        actions.getAssetInfo(assetUuid, setAssetInfo, logged)
    }, [])

    useEffect(() => {
        actions.getAssetMedia(assetUuid, setMedia, logged)
    }, [assetUuid])

    useEffect(() => {
        if (media) {
            let sortedImages: SortedImages = sortImages(media.filter((m: any) => m.media_type_name === "Image"))
            if (sortedImages.sorted_images.length > 0)
                setCardImage(sortedImages.sorted_images[0])
            else if (sortedImages.others.length > 0)
                setCardImage({
                    url_big: "",
                    url_small: "", name: sortedImages.others[0],
                    filename_big: sortedImages.others[0], filename_small: ""
                })
            else
                setCardImage(undefined)
            actions.getImagesURL(cardImage, setCardImageURLs)
        }
    }, [media])

    useEffect(() => {
        if (cardImage)
            actions.getImagesURL(cardImage, setCardImageURLs)
    }, [cardImage])

    return <>
        <DexxCard className={props.className}
            titles={{
                top: lp.token_a_ticker ?? "",
                middle: assetInfo ? assetInfo.name : <br />,
                bottom: <div className="flex justify-between"><div>
                    <div className="text-succ7">{lp.token_a_ticker}</div>
                    <div>{lp.amount_a}</div>
                </div>
                    <div className="text-right">
                        <div className="text-succ7">{lp.token_b_ticker}</div>
                        <div>{lp.amount_b}</div>
                    </div></div>
            }} topContent={{
                leftTop: "LIQUIDITY POOL NAME",
                leftBottom: { content: lp.lp_name, color: "succ7" },
                rightTop: { content: "", color: "" },
                rightBottom: { content: "", color: "" }
            }} bottomContent={{
                leftTop: "Expected Year Return",
                leftBottom: "0-250%"
            }} linkTo={{
                pathname: "/token/" + lp.token_a_uuid + "/lp",
                state: { from: "/earn" }
            }}
            buttonSpecs={{
                labelActive: "Fund",
                active: true,
                labelInactive: "",
                color: "succ7"
            }}
            cardImageURLs={cardImageURLs}
            imageBgColor="succ7_lighter" />
    </>
}